export default {
  content: {
    bottom: "auto",
    left: "50%",
    marginRight: "-50%",
    minWidth: 350,
    padding: 0,
    right: "auto",
    top: "30%"
  },
  overlay: {
    backgroundColor: "rgba(0,0,0,0.8)",
    overflow: "auto",
    zIndex: 1050
  }
};
